import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {CommunicationContentSubstitutionModel} from '../communicationContentSubstitution.model';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class CommunicationContentSubstitutionConverter extends HttpModelConverter<CommunicationContentSubstitutionModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): CommunicationContentSubstitutionModel {
        return new CommunicationContentSubstitutionModel();
    }

    protected enrichObject(result: CommunicationContentSubstitutionModel, src: CommunicationContentSubstitutionModel) {
        result.category = this.lovValueSummaryConverter.convert(src.category);
        result.businessContext = this.lovValueSummaryConverter.convert(src.businessContext);
    }
}
